import { Component, OnInit } from "@angular/core";
import { LoaderService } from './services/loader.service'

@Component({
  selector: 'hmb-logout'
  , templateUrl: 'onemomentplease.html'
})
export class LogoutComponent implements OnInit {
    constructor(private loaderService: LoaderService) { }
    public ngOnInit(): any {
        this.loaderService.emitChange(true);
        window.location.href = "/logout";
   }
}
